import { useState } from 'react'
import { classNames } from 'shared/lib/classNames/classNames'
import cls from './ImageWithSkeleton.module.scss'

export const ImageWithSkeleton = ({
    alt,
    className,
    onError,
    onLoad,
    src,
    ...props
}) => {
    const [loadedSrc, setLoadedSrc] = useState(null)
    const [failedSrc, setFailedSrc] = useState(null)
    const loaded = Boolean(src) && loadedSrc === src
    const failed = !src || failedSrc === src

    return (
        <img
            {...props}
            alt={alt}
            className={classNames(
                cls.ImageWithSkeleton,
                {
                    [cls.loaded]: loaded,
                    [cls.failed]: failed,
                },
                [className]
            )}
            onError={(event) => {
                setFailedSrc(src)
                onError?.(event)
            }}
            onLoad={(event) => {
                setFailedSrc(null)
                setLoadedSrc(src)
                onLoad?.(event)
            }}
            src={src || undefined}
        />
    )
}
